<template>
  <v-app>
    <v-content>
      <router-view/>
    </v-content>
  </v-app>
</template>

<script>
import NavbarLogotipo from './components/NavbarLogotipo.vue';
  export default {
    components: {
      NavbarLogotipo
    }
  }
</script>
